/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-11-25 11:01:12
 * @LastEditors: changfeng
 * @LastEditTime: 2023-06-27 17:59:26
 */
import { request } from '@umijs/max';
/** 获取当前的用户 GET /api/currentUser */
const FEISHU_AUTH_REDIRECT_URL = `${document.location.protocol}//${document.location.host}`;


export const searchAds =(params:DASHBOARD.SearchParams) => request('/api/top_ads/search', {
  method: 'POST',
  data: {
    ...params
  }
})


export const searchAdDetail =(params:{adId:string}) => request('/api/ad/detail', {
  method: 'GET',
  params: params
})

export function feishuLogin() {
  window.location.href =`https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${FEISHU_AUTH_REDIRECT_URL}/api/auth_callback/feishu&app_id=cli_a4fefebefb6ed013&state={"redirect_uri":"${FEISHU_AUTH_REDIRECT_URL}"}`
}


export const  fetchCurrentUser = () => {
  return request('/api/current_user', {
    method: 'GET',
    params:{}
  })
}


/** 马帮订单导出 */

export const fetchMbOrder = (params) => {
  return request("/api/order_export", {
    method:'POST',
    data: {
      ...params
    },
    responseType: 'blob', //必须要配置blob
  
  }, )
}


/** 店铺图片导出 */

export const fetchShopifyStorePic = (params) => {
  console.log('params',params)
  return request("/api/customily_images", {
    method:'GET',
    params: {
      ...params
    },
    responseType: 'blob', //必须要配置blob

  })
}


/** shopify订单统计 */

export const fetchShopifyOrderReport = (params) => {
  return request("/api/order_statistics", {
    method:'GET',
    params: {
      ...params
    },
    responseType: 'blob', //必须要配置blob

  })
}

/** shopify订单导出预览 */
export const fetchShopifyOrderPreview = (params) => {
  return request("/api/order_statistics_preview", {
    method:'GET',
    params: {
      ...params
    },
    // responseType: 'blob', //必须要配置blob

  })
}

/** 获取shopify店铺列表 */

export const fetchShopifyStoreList = () => {
  return request("/api/shop_url_list", {
    method:'GET',
    params: {
      // platform:'shopify'
    },

  })
}


/** 获取用户vendor */
export const fetchUserVendor = () => {
  return request("/api/vendors", {
    method:'GET',
    params: {
    },

  })
}


export const addUserVendor = (params) => {
  return request("/api/vendors", {
    method:'POST',
    data: {
      ...params
    },

  })
}

export const deleteUserVendor = (id) => {
  return request(`/api/vendors/${id}`, {
    method:'DELETE',


  })
}